module.exports = __webpack_public_path__ + "static/media/HEALTHY_LOW_BR.147772ae.mp4";